

const addUser = () => {
    
    var button = $("#add-user")
    var container = $("#users-container")
    var first_user = $("#first-user")
    var count = 2;
    
    var unitPrice = $(".amount-box .price span").attr('unit-price');
    var labelPrice = $(".amount-box .price span");
    
    if(button.length > 0) {
        
        button.click(function(){
            first_user.removeClass("col-md-12").addClass("col-md-6")
            container.append(`<div class="col-user col-12 col-md-6 participant" id="user-`+count+`">
                                <h4>Uczestnik numer `+count+`</h4>
                                <label class="control">
                                    <span class="label-box">imię<span class="star">*</span></span>
                                    <input type="text" name="firstname-`+count+`" class="required text_field">
                                </label>
                                <label class="control">
                                    <span class="label-box">nazwisko<span class="star">*</span></span>
                                    <input type="text" name="lastname-`+count+`" class="required text_field">
                                </label>
                                <label class="control">
                                    <span class="label-box">stanowisko<span class="star">*</span></span>
                                    <input type="text" name="position-`+count+`" class="required text_field">
                                </label>
                                <label class="control">
                                    <span class="label-box">telefon stacjonarny<span class="star">*</span></span>
                                    <input type="text" name="phone-`+count+`" class="required text_field">
                                </label>
                                <label class="control">
                                    <span class="label-box">telefon komórkowy</span>
                                    <input type="text" name="mobile_phone-`+count+`" class="text_field">
                                </label>
                                <label class="control">
                                    <span class="label-box">email<span class="star">*</span></span>
                                    <input type="email" name="email-`+count+`" class="required text_field">
                                </label>
                            </div>`)
            
            
            var position = $("#user-" + count).offset().top - 10
            
            $('html, body').animate({scrollTop: position}, 300)
            
            labelPrice.html(unitPrice*count);
            $('#price-total').val(unitPrice*count);
            
            count++

            /*
            $.validator.addClassRules('required', {
                required: true,
            });
            */

        })  
    }
}

const processApply = function(){

    $.validator.messages.required = 'To pole jest wymagane.';
    $.validator.messages.email = 'Adres email jest nieprawidłowy.';

    $('#apply-form').validate({
        errorPlacement: function(error, element) {

            if(element.hasClass('ckb')){
                error.insertAfter(element.parents('.checkbox__inner'));
            }else{
                error.insertAfter(element);
            }

        },
        submitHandler: function() {
            $('#apply-form-btn').html('WYSYŁAM ...');
            
            var path = $('#apply-form').attr('base-path');
            // console.log('step 1');

            var uczestnik = [];

            $('.participant').each(function(index){

                index = index + 1;
                var person = {};
                
                var firstname = $(this).find('input[name="firstname-'+index+'"]').val(),
                    lastname =  $(this).find('input[name="lastname-'+index+'"]').val(),
                    position = $(this).find('input[name="position-'+index+'"]').val(),
                    phone = $(this).find('input[name="phone-'+index+'"]').val(),
                    mobile_phone = $(this).find('input[name="mobile_phone-'+index+'"]').val(),
                    email = $(this).find('input[name="email-'+index+'"]').val();

                person['imie'] = firstname;
                person['nazwisko'] = lastname;
                person['stanowisko'] = position;
                person['telefon'] = phone;
                person['tel_kom'] = mobile_phone;
                person['email'] = email;
                
                uczestnik.push(person);

            });

            var osoba_zglaszajaca = {},
                firstname_a = $('#apply-form').find('input[name="firstname-a"]').val(),
                lastname_a = $('#apply-form').find('input[name="lastname-a"]').val(),
                position_a = $('#apply-form').find('input[name="position-a"]').val(),
                phone_a = $('#apply-form').find('input[name="phone-a"]').val(),
                mobile_phone_a = $('#apply-form').find('input[name="mobile_phone-a"]').val(),
                email_a = $('#apply-form').find('input[name="email-a"]').val(),
                message_a = $('#apply-form').find('textarea[name="message-a"]').val();
                
                osoba_zglaszajaca['imie'] = firstname_a;
                osoba_zglaszajaca['nazwisko'] = lastname_a;
                osoba_zglaszajaca['stanowisko'] = position_a;
                osoba_zglaszajaca['telefon'] = phone_a;
                osoba_zglaszajaca['tel_kom'] = mobile_phone_a;
                osoba_zglaszajaca['email'] = email_a;
                osoba_zglaszajaca['uwagi_dodatkowe'] = message_a;

            var firma = {},
                company_name = $('#apply-form').find('input[name="company-name"]').val(),
                company_nip = $('#apply-form').find('input[name="company-nip"]').val(),
                comapny_address = $('#apply-form').find('input[name="comapny-address"]').val(),
                company_postal_code = $('#apply-form').find('input[name="company-postal_code"]').val(),
                company_city = $('#apply-form').find('input[name="company-city"]').val(),
                company_phone = $('#apply-form').find('input[name="company-phone"]').val(),
                company_email = $('#apply-form').find('input[name="company-email"]').val();

                firma['nazwa'] = company_name;
                firma['miasto'] = company_city;
                firma['ulica'] = comapny_address;
                firma['nr_domu'] = "-";
                firma['nr_lokalu'] = "-";
                firma['kod'] = company_postal_code;
                firma['nip'] = company_nip;
                firma['telefon'] = company_phone;
                firma['email'] = company_email;

            var nazwa_szkolenia = $('#training-name').text(),
                data_szkolenia = $('#training-date').val(),
                data_szkolenia_koniec = $('#training-date-end').val(),
                miejsce_szkolenia = $("#training-place").text(),
                cena_szkolenia = $(".amount-box .price span").attr('unit-price'),
                cena_total = $('#price-total').val(),
                uwagi_dodatkowe = $('#apply-form').find('textarea[name="message-a"]').val(),
                ts = null,
                apikey = null;            
            
            var zgody = [];
            
            $('#apply-form').find('input.ckb').each(function(index){
                var item = {};
                
                if  ($(this).prop('checked') == true){
                    item['txt'] = $(this).val();
                 
                    zgody.push(item);
                }
            });
            
            // send message
            $.ajax({
                url: path + "ajax/apply-form-message",
                type: 'POST',
                dataType: "json",
                data: {
                    uczestnik: uczestnik,
                    osoba_zglaszajaca: osoba_zglaszajaca,
                    osoba_zglaszajaca_email: email_a,
                    firma: firma,
                    nazwa_szkolenia: nazwa_szkolenia,
                    data_szkolenia: data_szkolenia,
                    data_szkolenia_koniec: data_szkolenia_koniec,
                    miejsce_szkolenia: miejsce_szkolenia,
                    zgody: zgody,
                    cena: cena_total
                },
                success: function (data) {
                    console.log('success MESSAGE');
                    //console.log('success', data);
                    $('#apply-form-btn').html('DZIĘKUJEMY :)');
                    $('input.text_field').val('');
                    $('textarea.text_field').val('');
                },
                error: function (error) {
                    console.log('error MESSAGE', error);
                    $('#apply-form-btn').html('WYŚLIJ ZGŁOSZENIE');
                }
            });
                                    
            // API Call
            $.ajax({
                url: path + "ajax/apply-form",
                type: 'POST',
                dataType: "json",
                data: {
                    name: nazwa_szkolenia
                },
                success: function (data) {
                    if( data.status === 'success' && data.apikey != null && data.ts != null ){
                        //console.log('ajax success 1');

                        var apikey = data.apikey,
                            ts = data.ts;
                            /*
                            console.log("apikey: ", apikey);
                            console.log("ts: ", +ts);
                            console.log("nazwa_szkolenia: ", nazwa_szkolenia);
                            console.log("cena_szkolenia: ", cena_szkolenia);
                            console.log("data_szkolenia: ", data_szkolenia);
                            console.log("uczestnik: ", uczestnik);
                            console.log("osoba_zglaszajaca: ", osoba_zglaszajaca);
                            console.log("firma: ", firma);
                            */
                        $.ajax({
                            url: "https://pps.procrm.pl/apiSzkolenia.php",
                            type: 'POST',
                            data: {
                                ts: ts,                                
                                nazwa_szkolenia: nazwa_szkolenia,
                                data_szkolenia: data_szkolenia,
                                cena_szkolenia: cena_total,
                                uwagi_dodatkowe: uwagi_dodatkowe,
                                ApiKey: apikey,
                                uczestnik: uczestnik,
                                osoba_zglaszajaca: osoba_zglaszajaca,
                                firma: firma
                            },
                            dataType: "json",
                            success: function (data) {
                                console.log('success', data);
                            },
                            error: function (error) { console.log('ajax error 2', error); }
                        });
                    }
                },
                error: function (error) { console.log('ajax error 1'); }
            });
                
        }
    });

}

const importUserData = function(){

    $('#import-data-1').on('change', function(){

        if( $(this).prop('checked') === true ){
            var firstname_a = $('input[name="firstname-1"]').val(),
                lastname_a = $('input[name="lastname-1"]').val(),
                position_a = $('input[name="position-1"]').val(),
                phone_a = $('input[name="phone-1"]').val(),
                mobile_phone_a = $('input[name="mobile_phone-1"]').val(),
                email_a = $('input[name="email-1"]').val();
        }else{
            var firstname_a = '',
                lastname_a = '',
                position_a = '',
                phone_a = '',
                mobile_phone_a = '',
                email_a = '';
        }

        $('input[name="firstname-a"]').val(firstname_a);
        $('input[name="lastname-a"]').val(lastname_a);
        $('input[name="position-a"]').val(position_a);
        $('input[name="phone-a"]').val(phone_a);
        $('input[name="mobile_phone-a"]').val(mobile_phone_a);
        $('input[name="email-a"]').val(email_a);

    });

}

module.exports = {
    addUser,
    processApply,
    importUserData
};